import React, { useMemo, useState, useCallback } from "react";
import EvidenceModal from "./EvidenceModal";
import EvidenceTouchableRow from "./EvidenceTouchableRow";
import AchievementDropdown from "./AchievementDropdown";
import { resolveEvidenceSources } from "../evidenceImages";

function Achievements() {
    const [openKeys, setOpenKeys] = useState(null);

    const sources = useMemo(() => (openKeys ? resolveEvidenceSources(openKeys) : []), [openKeys]);
    const isOpen = sources.length > 0;

    const onOpen = useCallback((keys) => {
        setOpenKeys(keys);
    }, []);

    const onClose = useCallback(() => setOpenKeys(null), []);

    return (
        <section id="achievements" className="achievements-section">
            <h2 className="section-title">7. Achievements</h2>
            
            <AchievementDropdown title="Competitions" defaultOpen={true}>
                <div className="evidence-section-list">
                    <EvidenceTouchableRow
                        title="Best Research and Prototype"
                        evidenceKeys={["bestresearch_prototype"]}
                        onOpen={onOpen}
                    />
                    
                    <h3 className="evidence-subheading">Mr. and Ms. ECUP 2024</h3>
                    <EvidenceTouchableRow title="3rd Runner-Up" evidenceKeys={["3rdrunner"]} onOpen={onOpen} />
                    <EvidenceTouchableRow title="Best in Sports Wear" evidenceKeys={["sportswear"]} onOpen={onOpen} />

                    <h3 className="evidence-subheading">COE Year-End Party 2024</h3>
                    <EvidenceTouchableRow title="Ms. Face of the Night" evidenceKeys={["msface"]} onOpen={onOpen} />

                    <h3 className="evidence-subheading">ECUP 2023 Sports Events</h3>
                    <EvidenceTouchableRow title="Champion – Dance Blast" evidenceKeys={[]} onOpen={onOpen} />

                    <h3 className="evidence-subheading">ECUP 2024 Sports Events</h3>
                    <EvidenceTouchableRow title="1st Runner-Up – Volleyball" evidenceKeys={[]} onOpen={onOpen} />
                    <EvidenceTouchableRow title="Champion – Basketball" evidenceKeys={[]} onOpen={onOpen} />
                    <EvidenceTouchableRow title="Champion – Dance Blast" evidenceKeys={[]} onOpen={onOpen} />

                    <h3 className="evidence-subheading">ECUP 2025 Sports Events</h3>
                    <EvidenceTouchableRow title="3rd Runner-Up – Sack Race" evidenceKeys={["sackrace"]} onOpen={onOpen} />
                    <EvidenceTouchableRow title="1st Runner-Up – Volleyball" evidenceKeys={[]} onOpen={onOpen} />
                    <EvidenceTouchableRow title="2nd Runner-Up – Basketball (Girls)" evidenceKeys={[]} onOpen={onOpen} />

                    <h3 className="evidence-subheading">Bravo 2024</h3>
                    <EvidenceTouchableRow title="Cheerdance Champion" evidenceKeys={[]} onOpen={onOpen} />
                </div>
            </AchievementDropdown>

            <AchievementDropdown title="Leadership">
                <div className="evidence-section-list">
                    <EvidenceTouchableRow
                        title="Vice President for Organizational Affairs – FAICPES (SY 2025–2026)"
                        evidenceKeys={[]}
                        onOpen={onOpen}
                    />
                    <EvidenceTouchableRow
                        title="Secretary – FAICPES Organization (SY 2024–2025)"
                        evidenceKeys={[]}
                        onOpen={onOpen}
                    />
                    <EvidenceTouchableRow
                        title="Recognized for outstanding service and dedication"
                        evidenceKeys={[]}
                        onOpen={onOpen}
                    />
                    <EvidenceTouchableRow
                        title="Committee Member – Seminar: “Building Sustainable Future: Empowering Communities through HIV Awareness and Education”"
                        evidenceKeys={["committee"]}
                        onOpen={onOpen}
                    />
                    <EvidenceTouchableRow
                        title="Member, Digital Team (Creative Team) – FAICPES Organization (SY 2023–2024)"
                        evidenceKeys={["digteam"]}
                        onOpen={onOpen}
                    />
                    <EvidenceTouchableRow
                        title="Recognition for active participation and contributions in the FAICPES Organization (SY 2023–2024)"
                        evidenceKeys={["active"]}
                        onOpen={onOpen}
                    />
                    <EvidenceTouchableRow
                        title="Most Active Officer among Second Year Students – FAITH Computer Engineering Society (2025)"
                        evidenceKeys={["mostactive"]}
                        onOpen={onOpen}
                    />
                </div>
            </AchievementDropdown>

            <AchievementDropdown title="Certificates">
                <div className="evidence-section-list">
                    <EvidenceTouchableRow
                        title="Dean's Lister"
                        detail="Certificates on file (five terms)."
                        evidenceKeys={["dl1", "dl2", "dl3", "dl4", "dl5"]}
                        onOpen={onOpen}
                    />
                    <EvidenceTouchableRow
                        title="Certificate of Presentation"
                        detail=""
                        evidenceKeys={["certpresentation"]}
                        onOpen={onOpen}
                    />
                    <EvidenceTouchableRow
                        title="Basic ROTC Training Program (Military Science 1 & 2)"
                        detail="Certificate of Completion"
                        evidenceKeys={["certcompletion"]}
                        onOpen={onOpen}
                    />
                    <EvidenceTouchableRow
                        title="3rd Annual Conference – Center for Integrated Circuit and Device Research (CIDR)"
                        detail="“Connect. Innovate. Design. Revolutionize. Strengthening the Philippines' Microelectronics Ecosystem Through Strategic Collaboration and Talent Development” — August 11–12, 2025, Novotel, Araneta City, Quezon City"
                        evidenceKeys={["cidrcon"]}
                        onOpen={onOpen}
                    />
                </div>
            </AchievementDropdown>

            <EvidenceModal
                isOpen={isOpen}
                sources={sources}
                alt="Achievement evidence"
                onClose={onClose}
            />
        </section>
    );
}

export default Achievements;

